import apiClient from './axios';

/**
 * 권한 표 — 서버 저장(2026-10-02 대표님: 「권한 표를 서버에 저장하도록」).
 * 예전에는 저장한 브라우저에만 남아서 다른 계정 화면은 전혀 바뀌지 않았다.
 *
 * 읽기는 로그인한 모든 계정(고객·배송사 화면도 이 표로 메뉴를 가린다), 쓰기는 MASTER 만.
 * 저장된 값이 없으면 null — 화면은 코드 기본값(DEFAULT_MATRIX)을 쓴다.
 */
export const getPermissionMatrix = async () => {
  const response = await apiClient.get('/api/settings/permissions/current');
  return response.data?.data?.value ?? null;
};

export const savePermissionMatrix = async (matrix) => {
  const response = await apiClient.put('/api/settings/permissions', { value: matrix });
  return response.data?.data?.value ?? matrix;
};
